/*
OnlineOpinion v5.9.12
Released: 07/18/2017. Compiled 07/05/2018 02:16:12 PM -0500
Branch: 5.9.12 35b5b2ad883c34f46ba08db42faadc591299a198
Components: Full
UMD: disabled
The following code is Copyright 1998-2018 Opinionlab, Inc. All rights reserved. Unauthorized use is prohibited. This product and other products of OpinionLab, Inc. are protected by U.S. Patent No. 6606581, 6421724, 6785717 B1 and other patents pending. http://www.opinionlab.com
*/
/* eslint-disable */
(function (root, factory) {
  if (('disabled' === 'enabled') && (typeof define === 'function') && define.amd) {
    define([],factory);
  } else {
    root.OOo = factory();
  }
}(this, function () {

  window.OOo = {
    __detectBrowser: function(ua){

      var
        isOpera = Object.prototype.toString.call(window.opera) === '[object Opera]',
        isIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1,
        browser = {
          IE: !!isIE,
          MSEdge: ua.indexOf('Edge/') > -1,
          Opera: isOpera,
          WebKit: ua.indexOf('AppleWebKit/') > -1,
          Chrome: ua.indexOf('Chrome') > -1 && ua.indexOf('Edge/') ===-1,
          Gecko: ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') === -1,
          MobileSafari: /Apple.*Mobile.*Safari/.test(ua),
          iOs: ua.indexOf('iPad') > -1 || ua.indexOf('iPhone') > -1 || ua.indexOf('iPod') > -1,
          iOS67: ua.search(/OS 6(.*)|7(.*) like Mac OS/i) > -1,
          BlackBerry: ua.indexOf('BlackBerry') > -1,
          Fennec: ua.indexOf('Fennec') > -1,
          Safari: /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window.safari || safari.pushNotification),
          IEMobile: ua.indexOf('IEMobile') > -1,
          WindowsPhone: ua.toLowerCase().indexOf('windows phone') > -1,
          WindowsTablet: ua.toLowerCase().indexOf('windows nt') > -1 && ua.toLowerCase().indexOf('touch') > -1,
          OperaMobile: ua.search(/Opera (?:Mobi|Mini)/) > -1,
          Kindle: ua.search(/[ ](Kindle|Silk)/) > -1,
          isChromeIOS: /crios/i.test(ua),
          ua: ua,
          Android: /Android/.test(ua),
          facebookWebview: /FBAV/.test(ua),
          googleWebview: /GSA/.test(ua),
          AndroidChromiumWebview: /Chrome\/.* Mobile/.test(ua),
          iOsWebview: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/.test(ua)
        },
        unknown = false;

      browser.isMobile = (browser.MobileSafari || browser.BlackBerry || browser.Fennec || browser.IEMobile || browser.OperaMobile || browser.Kindle || browser.iOs || browser.Android || browser.WindowsPhone || browser.WindowsTablet || browser.AndroidChromiumWebview || browser.iOsWebview || browser.facebookWebview || browser.googleWebview);
      browser.isMobileNonIOS = (browser.isMobile && !browser.iOs);
      browser.isSafariDesktop = (browser.Safari) && (!browser.isMobile);
      return browser;
    }
  };

  OOo.Browser = OOo.__detectBrowser(navigator.userAgent);

  OOo.Cache = {};
  OOo.instanceCount = 0;
  OOo.K = function () {};

  var OnlineOpinion = OnlineOpinion || OOo;


  (function () {
    function $(id) { return document.getElementById(id); }


    function extend(destination, source) {
      var p;
      for (p in source) {
        if (source.hasOwnProperty(p)) {
          destination[p] = source[p];
        }
      }
      return destination;
    }

    function addEventListener(target, type, callback, captures) {
      if (target.addEventListener) {
        target.addEventListener(type, callback, captures);
      } else if (target.attachEvent) {
        target.attachEvent('on' + type, callback);
      }
    }

    function removeEventListener(target, type, callback, captures) {
      if (target.removeEventListener) {
        target.removeEventListener(type, callback, captures);
      } else if (target.detachEvent) {
        target.detachEvent('on' + type, callback);
      }
    }

    function toQueryString(object) {
      var strOut = [], p;
      for (p in object) {
        if (object.hasOwnProperty(p)) {
          strOut.push(p + '=' + (encodeURIComponent(object[p]) || ''));
        }
      }
      return strOut.join('&');
    }

    function getFormParams(opt) {
      var
        params = toQueryString(opt.metrics),
        prependCustomVar = (typeof opt.tealeafId !== 'undefined' ? removeCharacters(opt.tealeafId) : undefined) + '|' +
                          (typeof opt.clickTalePID !== 'undefined' ?  removeCharacters(opt.clickTalePID) : undefined) + '/' +
                          (typeof opt.clickTaleUID !== 'undefined' ? removeCharacters(opt.clickTaleUID) : undefined) + '/' +
                          (typeof opt.clickTaleSID !== 'undefined' ? removeCharacters(opt.clickTaleSID) : undefined);

      params += '&custom_var=' + OOo.createLegacyVars(opt.legacyVariables, prependCustomVar);

      if (opt.metrics.type === 'OnPage') { params += '|iframe'; }
      if (opt.asm) { params += '&asm=2'; }
      params += "&_" + 'rev=2';
      if (opt.customVariables) { params += '&customVars=' + encodeURIComponent(OOo.serialize(opt.customVariables)); }
      return params;
    }

    function appendOOForm(opt, frameName) {
      var rewrite = opt.referrerRewrite;
      opt.metrics.referer = location.href;
      opt.metrics.prev = encodeURIComponent(document.referrer);
      if (rewrite) { opt.metrics.referer = OOo.referrerRewrite(rewrite); }
      if (opt.constructCommentCardUrl) {
        var url = 'https://secure.opinionlab.com/ccc01/comment_card_d.asp';
        if (opt.commentCardUrl) {
          url = opt.commentCardUrl;
        }
        url += ('?' + getFormParams(opt));

        return url;
      } else {
        var
          d = document,
          form = d.createElement('form'),
          input = d.createElement('input');

        form.style.display = 'none';
        form.method = 'post';
        form.target = frameName || 'OnlineOpinion';
        form.action = 'https://secure.opinionlab.com/ccc01/comment_card_d.asp';
        if (opt.commentCardUrl) {
          form.action = opt.commentCardUrl;
        }
        input.name = 'params';
        input.value = getFormParams(opt);
        form.appendChild(input);
        d.body.appendChild(form);

        return form;
      }
    }

    function createMetrics() {
      return {
        width: screen.width,
        height: screen.height,
        referer: location.href,
        prev: document.referrer,
        time1: (new Date()).getTime(),
        time2: null,
        currentURL: location.href,
        ocodeVersion: '5.9.12'
      };
    }

    function truncateMetric(metric) {
      var newPath = '';
      if (metric && metric.search('://') > -1) {
        var pathArray=metric.split('/');
        for (var i = 3; i < pathArray.length; i++ ) {
          newPath += "/";
          newPath += pathArray[i];
        }
      }
      return newPath;
    }
    function removeCharacters(str) {
      return String(str).replace(/[\/&<>"' ]/g, '');
    }

    function createLegacyVars(legacyVarObj, prepend) {
      legacyVarObj = legacyVarObj || {};
      if (typeof legacyVarObj === 'string') { return prepend + '|' + removeCharacters(legacyVarObj); }
      return legacyVarObj.override ? removeCharacters(legacyVarObj.vars) : prepend + (legacyVarObj.vars ? '|' + removeCharacters(legacyVarObj.vars) : '');
    }

    function referrerRewrite(rewriteObj, loc) {
      if (!loc) { loc = location; }
      if (typeof rewriteObj === "string") return rewriteObj;
      return rewriteObj.searchPattern ? loc.href.replace(rewriteObj.searchPattern, rewriteObj.replacePattern) : rewriteObj.replacePattern;
    }

    function metaNameExists(name) {
      'use strict';

      var i,
        exists = false,
        metaTags = document.getElementsByTagName('meta');

      if (metaTags !== 'undefined') {
        for (i = 0; i < metaTags.length; i += 1) {
          if (metaTags[i].getAttribute('name') === name) {
            exists = true;
          }
        }
      }
      return exists;
    }

    var DYNAMIC_FRAME_NAME_IS_BUGGY = (function () {
      if (navigator.appName === "Microsoft Internet Explorer" && navigator.userAgent.search("MSIE 6") !== -1) { return true; }
      var container = document.body, el, isSupported;
      if (document.createElement && container && container.appendChild && container.removeChild) {
        el = document.createElement('iframe');
        isSupported = false;
        el.setAttribute('name', 'oo_test');
        el.style.display = 'none';
        container.appendChild(el);

        isSupported = !!!document.getElementsByName('oo_test')[0];
        container.removeChild(el);
        return isSupported;
      } else { return null; }
    }());

    function hideWaypoint(e, lf) {
      var evt = e || window.event,
        waypointContent = OOo.$('oo_waypoint_content'),
        waypointLogo =  OOo.$('oo_waypoint_company_logo'),
        waypointClose = OOo.$('oo_waypoint_close_prompt'),
        targetElement = evt.target;

      if (evt.srcElement && !evt.target) {targetElement = evt.srcElement;}
      if (evt.preventDefault && evt.stopPropagation) {
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }

      if ((targetElement !== waypointContent && !waypointContent.contains(targetElement)) && (targetElement !== waypointLogo && !waypointLogo.contains(targetElement)) || (targetElement.className === 'waypoint_icon' || targetElement.className === 'waypoint_icon last')) {
        var wpContainer = OOo.$('oo_waypoint_container'), parent = wpContainer.parentNode;
        parent.removeChild(wpContainer);
      }

      if (lf) {
        lf.focus();
      }
    }

    function getWaypoint() {
      var opt = this.options;
      var markup = "<div id='oo_waypoint_prompt' role='dialogue' aria-describedby='oo_waypoint_message'><div id='oo_waypoint_company_logo'></div><div id='oo_waypoint_content'><p id='oo_waypoint_message'>Select a category</p><p id='waypoint_icons'></p><p id='ol_waypoint_brand_logo'><span aria-label='Powered by OpinionLab.'></span></p></div><a id='oo_waypoint_close_prompt' href='#' aria-label='Close dialog'><div class='screen_reader'>Close dialogue</div><span aria-hidden='true'>&#10006;</span></a></div><!--[if IE 8]><style>/* IE 8 does not support box-shadow */#oo_waypoint_prompt #oo_waypoint_content { width: 400px; padding: 40px 49px 20px 49px; border: 1px solid #ccc; }</style><![endif]-->";
      if(typeof opt.wpmarkup !== 'undefined') {
        markup = opt.wpmarkup;
      }
      var prompt = OOo.$('oo_waypoint_prompt');
      if (prompt) {
        var container = OOo.$('oo_waypoint_container');
        this.showWaypoint(container);
        return;
      }
      this.showWaypoint(markup);
    }

    function showWaypoint(markup) {
      var
        d = document,
        linkCounter = 0,
        container = typeof markup === 'string' ? d.createElement('div') : markup,
        overlay = d.createElement('div'),
        headImage,
        imageText,
        footImage,
        waypointLinks,
        opt = this.options,
        categories = opt.categories,
        waypointClosePrompt,
        firstLink,
        lastFocused = d.activeElement,
        buttonText;

      overlay.id = 'oo_waypoint_overlay';
      container.id = 'oo_waypoint_container';
      container.style.visibility = 'hidden';

      if (typeof markup === 'string') {
        container.innerHTML = markup;
        d.body.appendChild(container);
      }

      container.appendChild(overlay);

      if (opt.companyLogo && opt.companySlogan) {
        headImage = new Image();
        headImage.src = opt.companyLogo;
        headImage.alt = opt.companySlogan;
        OOo.$('oo_waypoint_company_logo').appendChild(headImage);

        OOo.$('oo_waypoint_prompt').setAttribute('aria-label', opt.companySlogan);
      }

      footImage = new Image();
      footImage.src = opt.pathToAssets + 'oo_opinionlab_logo.png';
      footImage.alt = 'powered by OpinionLab';
      OOo.$('ol_waypoint_brand_logo').children[0].appendChild(footImage);

      waypointClosePrompt = OOo.$('oo_waypoint_close_prompt');

      for (var key in categories) {
        if (categories.hasOwnProperty(key)) {
          var newLink = document.createElement('a'),
            icon = opt.categories[key].icon,
            newButtonText = opt.categories[key].buttonText;

          newLink.className = 'waypoint_icon';
          newLink.href = '#';
          newLink.innerHTML = newButtonText + '<span class="screen_reader">This will open a new window</span>';

          if (icon && d.addEventListener) {
            newLink.style.backgroundImage = 'url(' + opt.pathToAssets + icon + ')';
          }

          if (typeof opt.categories[key].oCode === 'string') {
            OOo.addEventListener(newLink, 'click', (function (key){
              return function (e) {
                var evt = e || window.event;
                window.open(opt.categories[key].oCode, '_blank', 'scrollbars=yes,location=yes,menubar=yes,resizable=yes');
                OOo.hideWaypoint(evt, lastFocused);
              };
            })(key), false);

            newLink.onkeydown = (function (key) {
              return function (e) {
                var evt = e || window.event;
                if (evt.keyCode !== 13) { return; }
                window.open(opt.categories[key].oCode, '_blank', 'scrollbars=yes,location=yes,menubar=yes,resizable=yes');
                OOo.hideWaypoint(evt, lastFocused);
              };
            })(key);
          } else {
            OOo.addEventListener(newLink, 'click', (function (key){
              return function (e) {
                var evt = e || window.event;
                OOo.Waypoint[key].show(evt);
                OOo.hideWaypoint(evt, lastFocused);
              };
            })(key), false);

            newLink.onkeydown = (function (key) {
              return function (e) {
                var evt = e || window.event;
                if (evt.keyCode !== 13) { return; }
                OOo.Waypoint[key].show(evt);
                OOo.hideWaypoint(evt, lastFocused);
              };
            })(key);
          }

          linkCounter++;

          OOo.$('waypoint_icons').appendChild(newLink);
        }
      }

      OOo.addEventListener(container, 'click', function (e) { var evt = e || window.event; OOo.hideWaypoint(evt, lastFocused); }, false);
      waypointLinks = OOo.$('waypoint_icons').children;
      firstLink = waypointLinks[0];

      firstLink.onkeydown = function (e) {
        var evt = e || window.event;
        if (evt.keyCode === 9) {
          if (evt.shiftKey) {
            waypointClosePrompt.focus();
            return false;
          }
        }
      };

      waypointClosePrompt.onkeyup = function (e) {
        var evt = e || window.event;
        if (evt.keyCode !== 13) { return; }
        OOo.hideWaypoint(evt, lastFocused);
      };

      waypointClosePrompt.onkeydown = function (e) {
        var evt = e || window.event;
        if (evt.keyCode === 9) {
          if (!evt.shiftKey) {
            firstLink.focus();
            return false;
          }
        }
      };

      waypointLinks[linkCounter - 1].className = 'waypoint_icon last';

      container.style.visibility = 'visible';
      container.style.display = 'block';
      overlay.className = 'no_loading';

      if (opt.linkFocus === true) {
        firstLink.focus();
      }
    }



    function hidePrompt(e, lf) {
      var evt = e || window.event;
      if (evt.preventDefault && evt.stopPropagation) {
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }

      OOo.$('oo_container').style.display = 'none';

      if (lf) {
        lf.focus();
      }
    }

    function getPrompt() {
      var markup = "<div id='oo_invitation_prompt' role='dialog' aria-describedby='oo_invite_message'><div id='oo_invitation_company_logo'></div><div id='oo_invite_content'><p id='oo_invite_message'>After your visit, would you be willing to provide some quick feedback?<br /><br />(It will only take a minute)</p><p class='prompt_button'><a href='#' id='oo_launch_prompt'>Yes<span class='screen_reader'>This will open a new window</span></a></p><p class='prompt_button'><a href='#' id='oo_no_thanks'>No Thanks</a></p><p id='ol_invitation_brand_logo'><span aria-label='Powered by OpinionLab.'></span></p></div><a id='oo_close_prompt' href='#' aria-label='Close dialog'><div class='screen_reader'>Close dialog</div><span aria-hidden='true'>&#10006;</span></a></div><!--[if IE 8]><style>/* IE 8 does not support box-shadow */#oo_invitation_prompt #oo_invite_content { width: 400px; padding: 40px 49px 20px 49px; border: 1px solid #ccc; }</style><![endif]-->";
      var opt = this.options;
      if(typeof opt.inviteMarkup !== 'undefined') {
        markup = opt.inviteMarkup;
      } else if (typeof opt.events.prompt.promptMarkup) {
        markup = opt.events.prompt.promptMarkup;
      }
      var prompt = OOo.$('oo_invitation_prompt');
      if (prompt) {
        var container = OOo.$('oo_container');
        this.showPrompt(container);
        return;
      }
      this.showPrompt(markup);
    }

    function showPrompt(markup, launchFunc) {
      var
        d = document,
        container = typeof markup === 'string' ? d.createElement('div') : markup,
        overlay = d.createElement('div'),
        image,
        imageText,
        footImage,
        neverShowEl,
        opt = this.options,
        promptLauncher,
        noThanks,
        closePrompt,
        logo,
        lastFocused = d.activeElement;

      overlay.id = 'oo_invitation_overlay';
      container.id = 'oo_container';
      container.style.visibility = 'hidden';
      if (typeof markup === 'string') {
        container.innerHTML = markup;
        d.body.appendChild(container);
      }
      container.appendChild(overlay);

      promptLauncher = OOo.$('oo_launch_prompt');
      noThanks = OOo.$('oo_no_thanks');
      closePrompt = OOo.$('oo_close_prompt');
      logo = OOo.$('oo_invitation_company_logo');

      if (opt.companyLogo && opt.companySlogan) {
        image = new Image();
        image.src = opt.companyLogo;
        image.alt = opt.companySlogan;
        logo.appendChild(image);
        OOo.$('oo_invitation_prompt').setAttribute('aria-label', opt.companySlogan);
      } else if (opt.events.prompt.companyLogo && opt.events.prompt.companySlogan) {
        image = new Image();
        image.src = opt.events.prompt.companyLogo;
        image.alt = opt.events.prompt.companySlogan;
        logo.appendChild(image);
        OOo.$('oo_invitation_prompt').setAttribute('aria-label', opt.events.prompt.companySlogan);
      }
      footImage = new Image();
      footImage.src = opt.pathToAssets + 'oo_opinionlab_logo.png';
      footImage.alt = 'powered by OpinionLab';
      OOo.$('ol_invitation_brand_logo').children[0].appendChild(footImage);

      if (opt.callBacks) {
        if (typeof opt.callBacks.prompt === 'function') {
          opt.callBacks.prompt();
        }
        if (typeof opt.callBacks.yesClick === 'function') {
          OOo.addEventListener(promptLauncher, 'click', function () { opt.callBacks.yesClick(); }, false);
        }
        if (typeof opt.callBacks.noClick === 'function') {
          OOo.addEventListener(noThanks, 'click', function () { opt.callBacks.noClick(); }, false);
        }
        if (typeof opt.callBacks.closeClick === 'function') {
          OOo.addEventListener(closePrompt, 'click', function () { opt.callBacks.closeClick(); }, false);
        }
      }

      OOo.addEventListener(promptLauncher, 'click', launchFunc.bind(this), false);
      OOo.addEventListener(noThanks, 'click', function (e) { var evt = e || window.event; OOo.hidePrompt(evt, lastFocused); }, false);
      OOo.addEventListener(closePrompt, 'click', function (e) { var evt = e || window.event; OOo.hidePrompt(evt, lastFocused); }, false);

      promptLauncher.onkeyup = function (e) {
        var evt = e || window.event;
        if (evt.keyCode !== 13) { return; }
        launchFunc.bind(this);
      }.bind(this);

      promptLauncher.onkeydown = function (e) {
        var evt = e || window.event;
        if (evt.keyCode === 9) {
          if (evt.shiftKey) {
            closePrompt.focus();
            return false;
          }
        }
      };

      noThanks.onkeyup = function (e) {
        var evt = e || window.event;
        if (evt.keyCode !== 13) { return; }
        OOo.hidePrompt(evt, lastFocused);
      };

      closePrompt.onkeyup = function (e) {
        var evt = e || window.event;
        if (evt.keyCode !== 13) { return; }
        OOo.hidePrompt(evt, lastFocused);
      };

      closePrompt.onkeydown = function (e) {
        var evt = e || window.event;
        if (evt.keyCode === 9) {
          if (!evt.shiftKey) {
            promptLauncher.focus();
            return false;
          }
        }
      };

      container.style.visibility = 'visible';
      container.style.display = 'block';
      overlay.className = 'no_loading';

      lastFocused.blur();
      promptLauncher.focus();

    }


    function getEntryPrompt() {
      var promptMarkup = "<div id='oo_entry_prompt' role='dialog' aria-describedby='oo_entry_message'><div id='oo_entry_company_logo'></div><div id='oo_entry_content'><p id='oo_entry_message'>After your visit, would you be willing to provide some quick feedback?<br /><br />(It will only take a minute)</p><p class='entry_prompt_button'><a href='#' id='oo_launch_entry_prompt'>Yes<span class='screen_reader'>This will open a new window</span></a></p><p class='entry_prompt_button'><a href='#' id='oo_entry_no_thanks'>No Thanks</a></p><p id='ol_entry_brand_logo'><span aria-label='Powered by OpinionLab.'></span></p></div><a id='oo_entry_close_prompt' href='#' aria-label='Close dialog'><div class='screen_reader'>Close dialog</div><span aria-hidden='true'>&#10006;</span></a></div><!--[if IE 8]><style>/* IE 8 does not support box-shadow */#oo_entry_prompt #oo_entry_content { width: 400px; padding: 40px 49px 20px 49px; border: 1px solid #ccc; }</style><![endif]-->";
      var opt = this.options;
      if (typeof opt.events.prompt.promptMarkup) {
        promptMarkup = opt.events.prompt.promptMarkup;
      }
      var prompt = OOo.$('oo_entry_prompt');
      if (prompt) {
        var container = OOo.$('oo_container');
        this.showEntryPrompt(container);
        return;
      }
      this.showEntryPrompt(promptMarkup);
    }

    function showEntryPrompt(promptMarkup, launchFunc) {
      var
        d = document,
        container = typeof promptMarkup === 'string' ? d.createElement('div') : promptMarkup,
        overlay = d.createElement('div'),
        image,
        imageText,
        footImage,
        neverShowEl,
        opt = this.options,
        promptLauncher,
        noThanks,
        closePrompt,
        logo,
        lastFocused = d.activeElement;

      overlay.id = 'oo_entry_overlay';
      container.id = 'oo_container';
      container.style.visibility = 'hidden';
      if (typeof promptMarkup === 'string') {
        container.innerHTML = promptMarkup;
        d.body.appendChild(container);
      }
      container.appendChild(overlay);

      promptLauncher = OOo.$('oo_launch_entry_prompt');
      noThanks = OOo.$('oo_entry_no_thanks');
      closePrompt = OOo.$('oo_entry_close_prompt');
      logo = OOo.$('oo_entry_company_logo');

      if (opt.companyLogo && opt.companySlogan) {
        image = new Image();
        image.src = opt.companyLogo;
        image.alt = opt.companySlogan;
        logo.appendChild(image);
        OOo.$('oo_entry_prompt').setAttribute('aria-label', opt.companySlogan);
      } else if (opt.events.prompt.companyLogo && opt.events.prompt.companySlogan) {
        image = new Image();
        image.src = opt.events.prompt.companyLogo;
        image.alt = opt.events.prompt.companySlogan;
        logo.appendChild(image);
        OOo.$('oo_entry_prompt').setAttribute('aria-label', opt.events.prompt.companySlogan);
      }
      footImage = new Image();
      footImage.src = opt.pathToAssets + 'oo_opinionlab_logo.png';
      footImage.alt = 'powered by OpinionLab';
      OOo.$('ol_entry_brand_logo').children[0].appendChild(footImage);


      OOo.addEventListener(promptLauncher, 'click', launchFunc.bind(this), false);
      OOo.addEventListener(noThanks, 'click', function (e) { var evt = e || window.event; OOo.hidePrompt(evt, lastFocused); }, false);
      OOo.addEventListener(closePrompt, 'click', function (e) { var evt = e || window.event; OOo.hidePrompt(evt, lastFocused); }, false);

      promptLauncher.onkeyup = function (e) {
        var evt = e || window.event;
        if (evt.keyCode !== 13) { return; }
        launchFunc.bind(this);
      }.bind(this);

      promptLauncher.onkeydown = function (e) {
        var evt = e || window.event;
        if (evt.keyCode === 9) {
          if (evt.shiftKey) {
            closePrompt.focus();
            return false;
          }
        }
      };

      noThanks.onkeyup = function (e) {
        var evt = e || window.event;
        if (evt.keyCode !== 13) { return; }
        OOo.hidePrompt(evt, lastFocused);
      };

      closePrompt.onkeyup = function (e) {
        var evt = e || window.event;
        if (evt.keyCode !== 13) { return; }
        OOo.hidePrompt(evt, lastFocused);
      };

      closePrompt.onkeydown = function (e) {
        var evt = e || window.event;
        if (evt.keyCode === 9) {
          if (!evt.shiftKey) {
            promptLauncher.focus();
            return false;
          }
        }
      };

      container.style.visibility = 'visible';
      container.style.display = 'block';
      overlay.className = 'no_loading';

      lastFocused.blur();
      promptLauncher.focus();

    }

    var exitChat = function(a, b, c, d) {
      var x = "width=" + c;
      var y = "height=" + d;
      var win = window.open(a, b, x, y);
      var pollTimer = window.setInterval(function() {
        if (win.closed !== false) {
          window.clearInterval(pollTimer);
          OOo.oo_feedback.launchOOPopup();
        }
      }, 200);
    };

    var checkIfIE9orBelow = function() {
      return /MSIE\s/.test(navigator.userAgent) && parseFloat(navigator.appVersion.split("MSIE")[1]) < 10;
    };

    extend(OOo, {
      extend: extend,
      toQueryString: toQueryString,
      addEventListener: addEventListener,
      $: $,
      appendOOForm: appendOOForm,
      removeEventListener: removeEventListener,
      createMetrics: createMetrics,
      truncateMetric: truncateMetric,
      createLegacyVars: createLegacyVars,
      DYNAMIC_FRAME_NAME_IS_BUGGY: DYNAMIC_FRAME_NAME_IS_BUGGY,
      getFormParams: getFormParams,
      referrerRewrite: referrerRewrite,
      hidePrompt: hidePrompt,
      getPrompt: getPrompt,
      showPrompt: showPrompt,
      hideWaypoint: hideWaypoint,
      getWaypoint: getWaypoint,
      showWaypoint: showWaypoint,
      getEntryPrompt: getEntryPrompt,
      showEntryPrompt: showEntryPrompt,
      exitChat: exitChat,
      checkIfIE9orBelow: checkIfIE9orBelow
    });
  }());
  (function () {
    function serialize(obj) {
      if (!obj) { return null; }
      switch (typeof obj) {
        case 'number':
        case 'boolean':
        case 'function':
          return obj;
        case 'string':
          return '\"' + obj + '\"';
        case 'object':
          var str, i, len, key;
          if (obj.constructor === Array || typeof obj.callee !== 'undefined') {
            str = '[';
            len = obj.length;
            for (i = 0; i < len - 1; i += 1) { str += serialize(obj[i]) + ','; }
            str += serialize(obj[i]) + ']';
          } else {
            str = '{';
            for (key in obj) {
              if (obj.hasOwnProperty(key)) { str += key + ':' + serialize(obj[key]) + ','; }
            }
            str = str.replace(/\,$/, '') + '}';
          }
          return str;
        default:
          return null;
      }
    }

    OOo.extend(OOo, {serialize: serialize});
  }());
  (function () {
    function checkTunnel(path, tunnel, cookieName) {
      var previousStep;
      if (path.search(tunnel[0]) !== -1) {
        OOo.createCookieOrStorage(this.options, cookieName, 0);
        return false;
      } else if (OOo.readCookieOrStorage(this.storage, cookieName)) { // see if the tunnel was started
        previousStep = parseInt(OOo.readCookieOrStorage(this.options, cookieName), 10);
        if ((path.search(tunnel[previousStep + 1]) !== -1) && (previousStep + 1 !== tunnel.length - 1)) {
          OOo.createCookieOrStorage(this.options, cookieName, previousStep + 1);
          return false;
        } else if (path.search(tunnel[previousStep]) !== -1) {
          return false;
        } else if (previousStep + 1 === tunnel.length - 1 && path.search(tunnel.pop()) !== -1) {
          OOo.eraseCookieOrStorage(this.options, cookieName);
          return true;
        } else {
          OOo.eraseCookieOrStorage(this.options, cookieName);
          return false;
        }
      } else { return false; } // we are not even in the tunnel
    }

    OOo.extend(OOo, {
      checkTunnel: checkTunnel
    });
  }());
  (function () {
    SHA256 = {};

    SHA256.K = [
      0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b,
      0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01,
      0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7,
      0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
      0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152,
      0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
      0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc,
      0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
      0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819,
      0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08,
      0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f,
      0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
      0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];

    SHA256.Uint8Array = function(length) {
      if (typeof Uint8Array !== 'undefined') {
        return new Uint8Array(length);
      } else {
        return new Array(length);
      }
    };

    SHA256.Int32Array = function(length) {
      if (typeof Int32Array !== 'undefined') {
        return new Int32Array(length);
      } else {
        return new Array(length);
      }
    };

    SHA256.setArray = function(target, source) {
      if (typeof Uint8Array !== 'undefined') {
        target.set(source);
      } else {
        for (var i = 0; i < source.length; i++) {
          target[i] = source[i];
        }
        for (i = source.length; i < target.length; i++) {
          target[i] = 0;
        }
      }
    };

    SHA256.digest = function(message) {
      var h0 = 0x6a09e667;
      var h1 = 0xbb67ae85;
      var h2 = 0x3c6ef372;
      var h3 = 0xa54ff53a;
      var h4 = 0x510e527f;
      var h5 = 0x9b05688c;
      var h6 = 0x1f83d9ab;
      var h7 = 0x5be0cd19;
      var K = SHA256.K;
      if (typeof message == 'string') {
        var s =  unescape(encodeURIComponent(message)); // UTF-8
        message = SHA256.Uint8Array(s.length);
        for (var i = 0; i < s.length; i++) {
          message[i] = s.charCodeAt(i) & 0xff;
        }
      }
      var length = message.length;
      var byteLength = Math.floor((length + 72) / 64) * 64;
      var wordLength = byteLength / 4;
      var bitLength = length * 8;
      var m = SHA256.Uint8Array(byteLength);
      SHA256.setArray(m, message);
      m[length] = 0x80;
      m[byteLength - 4] = bitLength >>> 24;
      m[byteLength - 3] = (bitLength >>> 16) & 0xff;
      m[byteLength - 2] = (bitLength >>> 8) & 0xff;
      m[byteLength - 1] = bitLength & 0xff;
      var words = SHA256.Int32Array(wordLength);
      var byteIndex = 0;
      for (i = 0; i < words.length; i++) {
        var word = m[byteIndex] << 24;
        word |= m[byteIndex + 1] << 16;
        word |= m[byteIndex + 2] << 8;
        word |= m[byteIndex + 3];
        words[i] = word;
        byteIndex += 4;
      }
      var w = SHA256.Int32Array(64);
      for (var j = 0; j < wordLength; j += 16) {
        for (i = 0; i < 16; i++) {
          w[i] = words[j + i];
        }
        for (i = 16; i < 64; i++) {
          var v = w[i - 15];
          var s0 = (v >>> 7) | (v << 25);
          s0 ^= (v >>> 18) | (v << 14);
          s0 ^= (v >>> 3);
          v = w[i - 2];
          var s1 = (v >>> 17) | (v << 15);
          s1 ^= (v >>> 19) | (v << 13);
          s1 ^= (v >>> 10);
          w[i] = (w[i - 16] + s0 + w[i - 7] + s1) & 0xffffffff;
        }
        var a = h0;
        var b = h1;
        var c = h2;
        var d = h3;
        var e = h4;
        var f = h5;
        var g = h6;
        var h = h7;
        for (i = 0; i < 64; i++) {
          s1 = (e >>> 6) | (e << 26);
          s1 ^= (e >>> 11) | (e << 21);
          s1 ^= (e >>> 25) | (e << 7);
          var ch = (e & f) ^ (~e & g);
          var temp1 = (h + s1 + ch + K[i] + w[i]) & 0xffffffff;
          s0 = (a >>> 2) | (a << 30);
          s0 ^= (a >>> 13) | (a << 19);
          s0 ^= (a >>> 22) | (a << 10);
          var maj = (a & b) ^ (a & c) ^ (b & c);
          var temp2 = (s0 + maj) & 0xffffffff;
          h = g;
          g = f;
          f = e;
          e = (d + temp1) & 0xffffffff;
          d = c;
          c = b;
          b = a;
          a = (temp1 + temp2) & 0xffffffff;
        }
        h0 = (h0 + a) & 0xffffffff;
        h1 = (h1 + b) & 0xffffffff;
        h2 = (h2 + c) & 0xffffffff;
        h3 = (h3 + d) & 0xffffffff;
        h4 = (h4 + e) & 0xffffffff;
        h5 = (h5 + f) & 0xffffffff;
        h6 = (h6 + g) & 0xffffffff;
        h7 = (h7 + h) & 0xffffffff;
      }
      var hash = SHA256.Uint8Array(32);
      for (i = 0; i < 4; i++) {
        hash[i] = (h0 >>> (8 * (3 - i))) & 0xff;
        hash[i + 4] = (h1 >>> (8 * (3 - i))) & 0xff;
        hash[i + 8] = (h2 >>> (8 * (3 - i))) & 0xff;
        hash[i + 12] = (h3 >>> (8 * (3 - i))) & 0xff;
        hash[i + 16] = (h4 >>> (8 * (3 - i))) & 0xff;
        hash[i + 20] = (h5 >>> (8 * (3 - i))) & 0xff;
        hash[i + 24] = (h6 >>> (8 * (3 - i))) & 0xff;
        hash[i + 28] = (h7 >>> (8 * (3 - i))) & 0xff;
      }
      return hash;
    };

    SHA256.hash = function(message) {
      var digest = SHA256.digest(message);
      var hex = '';
      for (i = 0; i < digest.length; i++) {
        var s = '0' + digest[i].toString(16);
        hex += s.length > 2 ? s.substring(1) : s;
      }
      return hex;
    };

    OOo.extend(OOo, {sha256: SHA256.hash});

  }());
  (function () {
    function checkAbandonment(abandonmentObject, loc) {
      if (!loc) { loc = location; }
      var
        cookieName = abandonmentObject.cookieName || 'oo_abandon',
        cookie = OOo.readCookieOrStorage(this.options, cookieName),
        startPage = abandonmentObject.startPage,
        endPage = abandonmentObject.endPage,
        middle = abandonmentObject.middle;

      if (!cookie) {
        if (loc.pathname.indexOf(startPage) !== -1) { OOo.createCookieOrStorage(this.options, cookieName); }
        return false;
      } else if (loc.pathname.indexOf(endPage) !== -1) {
        OOo.eraseCookieOrStorage(this.options, cookieName);
        return false;
      } else if (loc.pathname.search(middle) !== -1) {
        return false;
      } else {
        OOo.eraseCookieOrStorage(this.options, cookieName);
        return true;
      }
    }

    OOo.extend(OOo, {
      checkAbandonment: checkAbandonment
    });
  }());
  (function () {
    function checkThirdPartyCookies(cArray) {
      var i, cookieValue;
      for (i = cArray.length - 1; i >= 0; i -= 1) {
        if (cArray[i].read) {
          cookieValue = OOo.readCookieOrStorage(this.options, cArray[i].name);
          if (!!cookieValue && cookieValue === cArray[i].value) {
            return true;
          } else if (typeof cArray[i].value === 'undefined' && !!OOo.readCookieOrStorage(this.options, cArray[i].name)) {
            return true;
          }
        }
      }
      return false;
    }

    function setThirdPartyCookies(cArray) {
      var i;
      for (i = cArray.length - 1; i >= 0; i -= 1) {
        if (cArray[i].set) { OOo.createCookieOrStorage(this.options, cArray[i].name, cArray[i].value, cArray[i].expiration); }
      }
    }

    OOo.extend(OOo, {
      checkThirdPartyCookies: checkThirdPartyCookies,
      setThirdPartyCookies: setThirdPartyCookies
    });
  }());

  OOo.extend(Function.prototype, (function () {
    if (typeof Function.prototype.bind !== "undefined") { return; }
    var slice = Array.prototype.slice;

    function update(array, args) {
      var arrayLength = array.length, length = args.length;
      while (length) {
        length -= 1;
        array[arrayLength + length] = args[length];
      }
      return array;
    }

    function merge(array, args) {
      array = slice.call(array, 0);
      return update(array, args);
    }

    function bind(context) {
      if (arguments.length < 2 && typeof context === "undefined") { return this; }
      var self = this, args = slice.call(arguments, 1);
      return function () {
        var a = merge(args, arguments);
        return self.apply(context, a);
      };
    }

    return {
      bind: bind
    };
  }()));

  (function() {
    function getCookieDomain(loc) {
      if (!loc) { loc = location; }

      var domain;
      if (loc.host.search(/\.[a-z]+/) !== -1) {
        domain = loc.host.split('.').reverse();
        if (domain.length > 3) { return loc.host; }
        domain = '.' + domain[1] + '.' + domain[0];
      } else { domain = loc.host; }
      return domain;
    }

    function createCookie(name, value, seconds, domain) {
      var date = '',
        expires = '';

      if (seconds) {
        date = new Date();
        date.setTime(date.getTime() + (seconds * 1000));
        expires = "; expires=" + date.toGMTString();
      }

      if (domain) {
        document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain + ";";
      } else if (location.host !== getCookieDomain()) {
        document.cookie = name + "=" + value + expires + "; path=/; domain=" + getCookieDomain() + ";";
      } else {
        document.cookie = name + "=" + value + expires + "; path=/;";
      }
    }

    function readCookie(name) {
      var nameEQ = name + "=",
        ca = document.cookie.split(';'),
        c, i;

      for (i = 0; i < ca.length; i += 1) {
        c = ca[i];
        while (c.charAt(0) === ' ') { c = c.substring(1, c.length); }
        if (c.indexOf(nameEQ) === 0) { return c.substring(nameEQ.length, c.length); }
      }
      return null;
    }

    function eraseCookie(name) {
      createCookie(name, "", -1);
    }

    function createCookieOrStorage(opt, name, value, seconds, domain) {
      var name = name || '',
        value = value || '',
        seconds = seconds || 0;

      opt.useBrowserStorage ? (OOo.createBrowserStorageItem(name, value, seconds)) : (OOo.createCookie(name, value, seconds, domain));
    }

    function readCookieOrStorage(opt, name) {
      return opt.useBrowserStorage ? (OOo.readBrowserStorageItem(name)) : (OOo.readCookie(name));
    }

    function eraseCookieOrStorage(opt, name) {
      opt.useBrowserStorage ? (OOo.eraseLocalStorageItem(name)) : (OOo.eraseCookie(name));
    }

    function hasLocalStorage() {
      var oo_test = "oo_test";

      try {
        localStorage.setItem(oo_test, oo_test);
        localStorage.removeItem(oo_test);
        return true;
      } catch (e) {
        return false;
      }
    }

    function hasSessionStorage() {
      var oo_test = "oo_test";

      try {
        sessionStorage.setItem(oo_test, oo_test);
        sessionStorage.removeItem(oo_test);
        return true;
      } catch (e) {
        return false;
      }
    }

    function createBrowserStorageItem(name, value, seconds) {
      var now = (new Date()).getTime(),
        seconds = seconds || 0;

      if (hasSessionStorage && (typeof seconds === "undefined" || seconds === 0)) {
        sessionStorage.setItem(name, JSON.stringify({ oo_val: value, dateSet: now }));
        return;
      } else {
        if (hasLocalStorage) {
          localStorage.setItem(name, JSON.stringify({ oo_val: value, dateSet: now, dateExpire: (seconds * 1000) }));
        }
      }
    }

    function readBrowserStorageItem(name) {
      var sessionStorageItem = JSON.parse(sessionStorage.getItem(name)),
        localStorageItem = JSON.parse(localStorage.getItem(name));

      if (sessionStorageItem && sessionStorageItem.oo_val) {
        return sessionStorageItem.oo_val;
      } else if (localStorageItem && ((new Date()).getTime() >= (localStorageItem.dateSet + localStorageItem.dateExpire))) {
        localStorage.removeItem(name);
        return null;
      } else {
        if (localStorageItem && localStorageItem.oo_val) {
          return localStorageItem.oo_val;
        } else {
          return null;
        }
      }
    }

    function eraseLocalStorageItem(name) {
      if (hasLocalStorage) {
        if (localStorage.getItem(name)) {
          localStorage.removeItem(name);
        }
      }
    }

    OOo.extend(OOo, {
      getCookieDomain: getCookieDomain,
      createCookie: createCookie,
      readCookie: readCookie,
      eraseCookie: eraseCookie,
      createBrowserStorageItem: createBrowserStorageItem,
      readBrowserStorageItem: readBrowserStorageItem,
      eraseLocalStorageItem: eraseLocalStorageItem,
      createCookieOrStorage: createCookieOrStorage,
      readCookieOrStorage: readCookieOrStorage,
      eraseCookieOrStorage: eraseCookieOrStorage
    });
  }());
  OOo.Ocode = function (options) {
    var browser = OOo.Browser, opt, rewrite;
    if (options.disableMobile && browser.isMobile) { return; }
    if (options.disableNoniOS && browser.isMobileNonIOS) { return; }
    OOo.instanceCount += 1;

    this.options = {

      tealeafCookieName: 'TLTSID'
    };

    OOo.extend(this.options, options);

    opt = this.options;
    opt.metrics = OOo.createMetrics();

    this.frameName = opt.onPageCard ? 'OnlineOpinion' + OOo.instanceCount : 'OnlineOpinion';
    if (opt.cookie && OOo.Ocode.matchUrl.call(this, opt.cookie, location)) { return; }

    if (opt.thirdPartyCookies && OOo.checkThirdPartyCookies(opt.thirdPartyCookies)) { return; }

    if (opt.abandonment && !OOo.checkAbandonment(opt.abandonment)) { return; }

    if (opt.tunnel && !OOo.checkTunnel(location.pathname, opt.tunnel.path, opt.tunnel.cookieName)) { return; }

    if (opt.events && opt.events.onSingleClick) { this.singProbability = Math.random() < 1 - opt.events.onSingleClick / 100; }

    opt.tealeafId = OOo.readCookieOrStorage(opt, opt.tealeafCookieName) || OOo.readCookieOrStorage(opt, opt.sessionCookieName);

    if (opt.events) {
      this.setupEvents();
      if (opt.events.disableLinks || opt.events.disableFormElements) { this.setupDisableElements(); }
    }

    if (opt.floating) {
      this.floating();
    } else if (opt.bar) {
      this.bar();
    } else if (opt.tab) {
      this.tab();
    }
  };

  OOo.Ocode.prototype = {
    show: function (e, trigger) {

      var evt = e || window.event;

      if (trigger !== 'exit' && trigger !== 'entry' && trigger !== 'onSingleClick') {
        if (evt.preventDefault && evt.stopPropagation) {
          evt.preventDefault();
          evt.stopPropagation();
        } else {
          evt.returnValue = false;
        }
      }

      if (this.onPageCardVisible) { return; }
      var opt = this.options, uiElement;
      if (opt.events && opt.events.prompt) {
        if (opt.cookie) OOo.eraseCookieOrStorage(opt, opt.cookie.name || 'oo_r');
        OOo.hidePrompt(evt);
      }
      if (this.interruptShow) { return; }
      if (!this.floatingLogo && opt.cookie && OOo.Ocode.matchUrl.call(this, opt.cookie)) { return; }
      if (!opt.floating && opt.events && this.singProbability) { return; }
      if (opt.events && opt.events.onSingleClick) { this.singProbability = true; }

      if (opt.cookie) { OOo.Ocode.tagUrl.call(this, opt.cookie); }

      if (opt.thirdPartyCookies) {
        if (OOo.checkThirdPartyCookies(opt.thirdPartyCookies)) { return; }
        OOo.setThirdPartyCookies(opt.thirdPartyCookies);
      }

      if (this.floatingLogo) { this.floatingLogo.children[0].blur(); }

      if (this.floatingLogo && opt.disappearOnClick) { this.floatingLogo.style.display = 'none'; }

      if (typeof window.ClickTale === 'function') {
        if (!opt.clickTalePID) {
          opt.clickTalePID = window.ClickTaleGetPID() || null;
        }
        opt.clickTaleUID = window.ClickTaleGetUID() || null;
        opt.clickTaleSID = window.ClickTaleGetSID() || null;

        var receiveMessage = function (e) {
          if (e.origin === 'https://secure.opinionlab.com') {
            if (typeof window.ClickTaleEvent === 'function' && e.data !== '') {
              var ctData = JSON.parse(e.data),
                clickTaleEvent = window.ClickTaleEvent;
              for (var key in ctData) {
                clickTaleEvent(key + ':' + ctData[key]);
              }
            }
          }
        };

        OOo.addEventListener(window, 'message', receiveMessage, false);
      }
      if (opt.onPageCard && !OOo.Browser.isMobile) {
        this.setupOnPageCC();
      } else {
        this.launchOOPopup();
      }

      uiElement = opt.floating || opt.tab || opt.bar;
      if (uiElement && typeof uiElement.onClickCallback === 'function') { uiElement.onClickCallback(); }

    }
  };

  OOo.extend(OOo.Ocode, {
    tagUrl: function (cookie, loc) {
      if (!loc) { loc = location; }
      var
        cookieName = cookie.name || 'oo_r',
        url = cookie.type === 'page' ? loc.href : loc.hostname,
        prevValue = OOo.readCookieOrStorage(this.options, cookieName) || '';

      if (OOo.Ocode.matchUrl.call(this, cookie, loc)) { return; }

      OOo.createCookieOrStorage(this.options, cookieName, prevValue + OOo.sha256(url), cookie.expiration, cookie.domain);
    },
    matchUrl: function (cookie, loc) {
      if (!loc) { loc = location; }
      var cookieVal = OOo.readCookieOrStorage(this.options, cookie.name || 'oo_r'), url;
      if (!cookieVal) { return false; }
      url = cookie.type === 'page' ? loc.href : loc.hostname;
      return cookieVal.search(OOo.sha256(url)) !== -1;
    }
  });

  (function () {
    var windowCount = 0;

    function launchOOPopup() {
      var
        opt = this.options,
        popupDimensions = opt.newWindowSize || [545, 325],
        popupCoordinates = [
          parseInt((opt.metrics.height - popupDimensions[1]) / 2, 10),
          parseInt((opt.metrics.width - popupDimensions[0]) / 2, 10)
        ],
        form, win,
        popupOptions = 'resizable=yes,location=no,status=no,scrollbars=1,width=' + popupDimensions[0] + ',height=' + popupDimensions[1] + ',top=' + popupCoordinates[0] + ',left=' + popupCoordinates[1],
        windowName = 'OnlineOpinion',
        winUrl;

      if (opt.newWindow) {
        windowName = windowName + (windowCount++);
      }

      opt.metrics.time2 = (new Date()).getTime();
      opt.metrics.type = 'Popup';


      if (OOo.Browser.isChromeIOS) {
        windowName = '_blank';
      }

      if(OOo.Browser.isSafariDesktop) {
        opt.constructCommentCardUrl = true;
      }

      if (opt.constructCommentCardUrl) {
        winUrl = OOo.appendOOForm(opt, windowName);
        win = window.open(winUrl, windowName, popupOptions);
      } else {
        form = OOo.appendOOForm(opt, windowName);
        var winUrl = 'https://secure.opinionlab.com/ccc01/comment_card_d.asp?' + form.children[0].value;

        if (opt.commentCardUrl) {
          winUrl = opt.commentCardUrl + '?' + form.children[0].value;
        }
        if ((OOo.Browser.isMobile && OOo.Browser.ua.search('Android') !== -1) || !OOo.Browser.isMobile) {
          win = window.open(winUrl, windowName, popupOptions);
          form.submit();
        } else {
          win = window.open('', windowName, popupOptions);
          if (win.location.href === 'about:blank') {
            win.location.href = winUrl;
          } else {
            win.close();
            win = window.open(winUrl, windowName, popupOptions);
          }
          if (win && !OOo.Browser.isChromeIOS) {
            form.submit();
          }
        }
      }
    }

    OOo.extend(OOo.Ocode.prototype, {
      launchOOPopup: launchOOPopup
    });
  }());
  (function () {
    function setupEvents() {
      var
        events = this.options.events,
        addEvent = [false, false],
        eventTypes = ['onExit', 'onEntry'],
        exitEvent = 'beforeunload',
        eventType, interval, j, eventObj, i;

      if (OOo.Browser.Opera) {
        exitEvent = 'unload';
      }

      if (OOo.Browser.iOs) {
        exitEvent = 'pagehide';
      }

      if (events.prompt) {
        OOo.extend(this.options, {
          promptMarkup: events.prompt.promptMarkup,
          neverShowAgainButton: false,
          pathToAssets: events.prompt.pathToAssets
        });
      }

      for (j = eventTypes.length - 1; j >= 0; j -= 1) {
        eventType = eventTypes[j];

        if (events[eventType] instanceof Array) {
          eventObj = events[eventType];
          i = eventObj.length;
          while (i && !addEvent[j]) {
            i -= 1;
            if (window.location.href.search(eventObj[i].url) !== -1 && Math.random() >= 1 - eventObj[i].p / 100) { addEvent[j] = true; }
          }
        } else if (events[eventType] && Math.random() >= 1 - events[eventType] / 100) { addEvent[j] = true; }
      }

      if (addEvent[0]) {
        OOo.addEventListener(window, exitEvent, function (e) {
          var evt = e || window.event;
          this.show(evt, 'exit');
        }.bind(this), false);
      }
      if (addEvent[1]) {
        if (events.delayEntry) {
          window.setTimeout(function (e) {
            var evt = e || window.event;
            if (events.prompt) {
              this.getEntryPrompt();
            } else {
              this.show(evt, 'entry');
            }
          }.bind(this), events.delayEntry * 1000);
        } else {
          if (events.prompt) {
            this.getEntryPrompt();
          } else {
            (function (e) {
              var evt = e || window.event;
              this.show(evt, 'entry');
            }).bind(this)();
          }
        }
      }
    }

    function disableElements(e) {
      var evt = e || window.event, tar = e.target || e.srcElement, events = this.options.events, parent = tar.parentNode, MAXDEPTH = 5, depth = 0;
      while (parent && (tar.nodeName !== 'A' || tar.nodeName !== 'INPUT') && depth !== MAXDEPTH) {
        if (parent.nodeName === 'A') { tar = parent; }
        parent = parent.parentNode;
        depth += 1;
      }
      if (events.disableFormElements && (tar.tagName === "INPUT" || tar.tagName === "BUTTON") && (tar.type === 'submit' || tar.type === 'image' || tar.type === 'reset' || tar.type === 'button')) { this.interruptShow = true; }
      if (events.disableLinks && (tar.nodeName === 'A' || tar.nodeName === 'AREA') && tar.href.substr(0, 4) === 'http' && tar.href.search(events.disableLinks) !== -1) { this.interruptShow = true; }
    }

    function disableForms(e) {
      this.interruptShow = true;
    }

    function setupDisableElements() {
      OOo.addEventListener(document.body, 'mousedown', disableElements.bind(this));
      if (!this.options.events.disableFormElements) { return; }
      var forms = document.getElementsByTagName('form'), i;
      for (i = forms.length - 1; i >= 0; i -= 1) { OOo.addEventListener(forms[i], 'submit', disableForms.bind(this)); }
    }

    OOo.extend(OOo.Ocode.prototype, {
      setupEvents: setupEvents,
      setupDisableElements: setupDisableElements,
      getEntryPrompt: function () {
        OOo.getEntryPrompt.call(this);
      },
      showEntryPrompt: function (markup) {
        if (this.options.cookie) { OOo.Ocode.tagUrl.call(this, this.options.cookie); }
        OOo.showEntryPrompt.call(this, markup, this.show);
      }
    });
  }());

  OOo.extend(OOo.Ocode.prototype,  {
    floating: function () {
      var
        d = document,
        wrapper = this.floatingLogo = document.createElement('div'),
        up = d.createElement('div'),
        floatingBg = d.createElement('div'),
        hover = d.createElement('div'),
        hoverText = d.createElement('span'),
        opt = this.options.floating, //options for rendering floating logo
        contentEl = OOo.$(opt.contentId),
        logoOffset = '10px',
        wrapperId = opt.id,
        screenReader = d.createElement('span'),
        evt,
        initialHeight,
        amount, spacer, scrollEl, adjustLogo, wrapperHeight, safariLogo,
        mobileTouches = this.options.mobileTouches || 2,
        touches = 0;

      function getRightOfContent(el) {
        return el.offsetLeft + el.offsetWidth;
      }

      function adjustSpacer(e) {
        spacer.style.left = getRightOfContent(contentEl) + 'px';
      }

      screenReader.innerHTML = "Screen reader users: Please switch to forms mode for this link.";

      screenReader.className = "screen_reader";
      if (wrapperId) { wrapper.id = wrapperId; }
      wrapper.className = 'oo_feedback_float';
      floatingBg.className = 'oo_transparent';
      up.className = 'olUp';
      hover.className = 'olOver';

      up.tabIndex = 0;
      up.onkeyup = function (e) {
        evt = e || window.event;
        if (evt.keyCode !== 13) { return; }
        this.show(evt);
      }.bind(this);

      up.innerHTML = opt.caption || 'Feedback';
      wrapper.appendChild(screenReader);
      wrapper.appendChild(up);
      hoverText.innerHTML = opt.hoverCaption || 'Click here to<br>rate this page';
      hover.appendChild(hoverText);
      wrapper.appendChild(hover);

      wrapper.appendChild(floatingBg);

      function ieLogo(e) {
        var
          scrollTop = d.documentElement.scrollTop || d.body.scrollTop,
          clientHeight = d.documentElement.clientHeight || document.body.clientHeight;

        wrapper.style.top = (scrollTop + clientHeight - (wrapperHeight || 0) - 10) + 'px';
      }

      /*attach any special floating behavior to floating icon*/
      if (opt.position && opt.position.search(/Content/) && contentEl) {
        spacer = this.spacer = d.createElement('div');
        scrollEl = OOo.Browser.WebKit ? d.body : d.documentElement;

        spacer.id = 'oo_feedback_fl_spacer';
        spacer.style.left = getRightOfContent(contentEl) + 'px';
        d.body.appendChild(spacer);

        switch (opt.position) {
          case 'rightOfContent':
            adjustLogo = function (e) {
              wrapper.style.left = (getRightOfContent(contentEl) - scrollEl.scrollLeft) + 'px';
            };
            break;
          case 'fixedPreserveContent':
            adjustLogo = function (e) {
              var
                winWidth = OOo.Browser.IE ? d.body.clientWidth : window.innerWidth,
                scroll = scrollEl.scrollLeft;
              if (winWidth <= getRightOfContent(contentEl) + wrapper.offsetWidth + parseInt(logoOffset, 10)) {
                wrapper.style.left = (getRightOfContent(contentEl) - scroll) + 'px';
              } else {
                wrapper.style.left = '';
                wrapper.style.right = logoOffset;
              }
            };
            break;
          case 'fixedContentMax':
            adjustLogo = function (e) {
              var winWidth = OOo.Browser.IE ? d.body.clientWidth : window.innerWidth;
              if (winWidth <= getRightOfContent(contentEl) + wrapper.offsetWidth + parseInt(logoOffset, 10)) {
                wrapper.style.left = '';
                wrapper.style.right = logoOffset;
              } else {
                wrapper.style.left = (getRightOfContent(contentEl) - scrollEl.scrollLeft) + 'px';
                wrapper.style.right = '';
              }
            };
            break;
        }
        window.setTimeout(adjustLogo, 0);

        OOo.addEventListener(window, 'scroll', adjustLogo, false);
        OOo.addEventListener(window, 'resize', adjustLogo, false);

        OOo.addEventListener(window, 'resize', adjustSpacer, false);
      } else {
        wrapper.style.right = logoOffset;
      }

      if (!this.options.disableShow === true) {
        wrapper.onkeyup = function (e) {
          var evt = e || window.event;
          if (evt.keyCode !== 13) { return; }
          this.show(evt);
        }.bind(this);

        if (OOo.Browser.isMobile) {
          if ('ontouchstart' in window) {
            wrapper.ontouchstart = function (e) {
              var evt = e || window.event;
              if (evt.preventDefault && evt.stopPropagation) {
                evt.preventDefault();
                evt.stopPropagation();
              } else {
                evt.returnValue = false;
              }

              touches++;
            }.bind(this);

            wrapper.ontouchend = function (e) {
              var evt = e || window.event;
              if (touches >= mobileTouches) {
                this.show(evt);
                touches = 0;
              }
            }.bind(this);
          } else {
            wrapper.onclick = function (e) {
              var evt = e || window.event;
              this.show(evt);
            }.bind(this);
          }
        } else {
          wrapper.onclick = function (e) {
            var evt = e || window.event;
            this.show(evt);
          }.bind(this);
        }
      } else {
        OOo.appendWaypointMobile(wrapper, mobileTouches);
      }

      d.body.appendChild(wrapper);
    },
    removeFloatingLogo: function () {
      document.body.removeChild(this.floatingLogo);
      if (this.spacer) { document.body.removeChild(this.spacer); }
    }
  });

  OOo.extend(OOo.Ocode.prototype, {
    bar: function () {
      var d = document,
        wrapper = this.floatingLogo = d.createElement('a'),
        adjustBar, initialHeight, amount,
        currentScroll = d.documentElement.scrollTop || d.body.scrollTop,
        screenReaderEl = d.createElement('span'),
        opt = this.options,
        mobileTouches = this.options.mobileTouches || 2,
        touches = 0,
        ieSpan = d.createElement('span');

      function findPos(el) {
        var curleft = 0,
          curtop = 0;

        if (el.offsetParent) {
          do {
            curleft += el.offsetLeft;
            curtop += el.offsetTop;
          } while (el == el.offsetParent);

          return [curleft,curtop];
        }
      }

      function checkTabThrough(e) {
        var activeElement = document.activeElement, offset;
        if (!activeElement) return;
        offset = findPos(activeElement);
        if (!offset) return;
        if (offset[1] + activeElement.clientHeight > (window.innerHeight || document.body.clientHeight) + (window.pageYOffset || document.body.scrollTop) - wrapper.clientHeight) {
          if (navigator.appVersion.indexOf("MSIE 7.") !== -1) {
            window.scrollBy(0, 0);
          } else {
            window.scrollBy(0, activeElement.clientHeight + 20);
          }
        }
      }

      screenReaderEl.innerHTML = 'Launches comment card in new window';
      screenReaderEl.className = 'screen_reader';
      ieSpan.className = 'icon';
      this.reflowBar = OOo.K;
      wrapper.id = 'oo_bar';
      wrapper.href = '#';
      wrapper.innerHTML = opt.bar.caption || 'Feedback';
      wrapper.appendChild(screenReaderEl);
      wrapper.appendChild(ieSpan);

      if (typeof opt.tabIndex === 'number') {
        wrapper.tabIndex = opt.tabIndex;
      } else {
        wrapper.tabIndex = 0;
      }

      if (!this.options.disableShow === true) {

        if (OOo.Browser.isMobile) {
          if ('ontouchstart' in window) {
            wrapper.ontouchstart = function (e) {
              var evt = e || window.event;
              if (evt.preventDefault && evt.stopPropagation) {
                evt.preventDefault();
                evt.stopPropagation();
              } else {
                evt.returnValue = false;
              }

              touches++;
            }.bind(this);

            wrapper.ontouchend = function (e) {
              var evt = e || window.event;
              if (touches >= mobileTouches) {
                this.show(evt);
                touches = 0;
              }
            }.bind(this);
          } else {
            wrapper.onclick = function (e) {
              var evt = e || window.event;
              this.show(evt);
            }.bind(this);
          }

        } else {
          wrapper.onclick = function (e) {
            var evt = e || window.event;
            this.show(evt);
          }.bind(this);
        }
      } else {
        OOo.appendWaypointMobile(wrapper, mobileTouches);
      }

      document.body.className += document.body.className < 1 ? 'oo_bar' : ' oo_bar';
      document.body.appendChild(wrapper);

      OOo.addEventListener(document.body, 'keyup', checkTabThrough, false);
    }
  });

  OOo.extend(OOo.Ocode.prototype, {
    tab: function () {
      /*
        Legacy Tab markup
        <div class="oo_tab_right" id="oo_tab"><a href="#"><span></span></a></div>

        New WCAG tab markup
        <a id="oo_tab_1" class="oo_tab_right_1 small" tabindex="1">Feedback<span class="screen_reader">Launch comment card</span></a>
        */
      var d = document,
        wrapper = this.floatingLogo = d.createElement('div'),
        spanScreenReader = d.createElement('span'),
        div = d.createElement('div'),
        span = d.createElement('span'),
        opt = this.options.tab,
        a = d.createElement('a'),
        verbiage = 'Feedback',
        tabType = opt.tabType,
        position = 'right',
        mobileTouches = this.options.mobileTouches || 2,
        touches = 0,
        extendEveryPage = false,
        extendCookie = OOo.readCookieOrStorage(opt, 'oo_tab_extend'),
        extendExpiration = 2592000; // 30 days by default

      switch (tabType) {
        case 1:

          var ieSpan = d.createElement('span');
          wrapper = this.floatingLogo = d.createElement('a');
          spanScreenReader = d.createElement('span');

          wrapper.href = '#';

          wrapper.id = 'oo_tab_' + tabType;

          if (opt.position) {
            position = opt.position;
          }

          if (opt.extendEveryPage) {
            extendEveryPage = opt.extendEveryPage;
          }
          if (opt.extendExpiration) {
            extendExpiration = opt.extendExpiration;
          }

          wrapper.className = tabClass = 'oo_tab_' + position + '_' + tabType;
          spanScreenReader.className = 'screen_reader';
          ieSpan.className = 'icon';

          if (typeof opt.tabIndex === 'number') {
            wrapper.tabIndex = opt.tabIndex;
          } else {
            wrapper.tabIndex = 0;
          }

          if (opt.verbiage) {
            verbiage = opt.verbiage;
          }

          wrapper.innerHTML = verbiage;
          spanScreenReader.innerHTML = 'Launches comment card in new window';

          wrapper.appendChild(spanScreenReader);
          wrapper.appendChild(ieSpan);

          if (extendEveryPage) {
            setTimeout(function () {
              wrapper.className += ' small';
            }, 2500);
          } else {
            if (extendCookie === 'prevent') {
              wrapper.className += ' small';
            } else {
              var domain;
              if (opt.cookie && opt.cookie.domain) {
                domain = opt.cookie.domain;
              } else {
                domain = OOo.getCookieDomain();
              }
              OOo.createCookieOrStorage(opt, 'oo_tab_extend', 'prevent', extendExpiration, domain);
              setTimeout(function () {
                wrapper.className += ' small';
              }, 2500);
            }
          }

          break;
        default:
          wrapper = this.floatingLogo = d.createElement('a');

          wrapper.id = 'oo_tab';
          wrapper.className = 'oo_tab_' + (opt.position || position);
          wrapper.href = '#';

          if (!document.addEventListener || OOo.checkIfIE9orBelow()) {
            wrapper.className += ' oo_legacy';
          }

          if (opt.wcagBasePath) {
            wrapper.className += ' wcag';
          }

          var img = document.createElement('img');

          if (opt.iconPath) {
            img.setAttribute('src', opt.iconPath);
          } else {
            img.setAttribute('src', '/onlineopinionV5/oo_tab_icon_retina.gif');
          }

          img.setAttribute('alt', '');

          if (opt.verbiage) {
            verbiage = opt.verbiage;
          }
          var txt = document.createElement("textarea");
          txt.innerHTML = verbiage;
          verbiage = txt.value;

          var feedbackText = document.createTextNode(verbiage);

          wrapper.appendChild(img);
          wrapper.appendChild(feedbackText);

          if (spanScreenReader) {
            spanScreenReader.className = 'screen_reader';
            spanScreenReader.innerHTML = ' Will open a new window';
            wrapper.appendChild(spanScreenReader);
          }
      }


      if (!this.options.disableShow === true) {

        if (OOo.Browser.isMobile) {
          if ('ontouchstart' in window) {
            wrapper.ontouchstart = function (e) {
              var evt = e || window.event;
              if (evt.preventDefault && evt.stopPropagation) {
                evt.preventDefault();
                evt.stopPropagation();
              } else {
                evt.returnValue = false;
              }

              touches++;
            }.bind(this);

            wrapper.ontouchend = function (e) {
              var evt = e || window.event;
              if (touches >= mobileTouches) {
                this.show(evt);
                touches = 0;
              }
            }.bind(this);
          } else {
            wrapper.onclick = function (e) {
              var evt = e || window.event;
              this.show(evt);
            }.bind(this);
          }

        } else {
          wrapper.onclick = function (e) {
            var evt = e || window.event;
            this.show(evt);
          }.bind(this);
        }
      } else {
        OOo.appendWaypointMobile(wrapper, mobileTouches);
      }

      d.body.appendChild(wrapper);
    }
  });

  OOo.extend(OOo.Ocode.prototype, {
    setupOnPageCC: function() {
      var
        d = document,
        overlay = OOo.Cache.overlay || d.createElement('div'),
        wrapper = this.wrapper = d.createElement('div'),
        close = d.createElement('a'),
        iwrapper = d.createElement('div'),
        iclose = d.createElement('span'),
        frameName = this.frameName,
        frame = d.createElement(OOo.DYNAMIC_FRAME_NAME_IS_BUGGY ? '<iframe name="' + frameName + '">' : 'iframe'),
        tempContainer = d.createDocumentFragment(),
        thisOpt = this.options,
        opt = thisOpt.onPageCard,
        ONPAGE_REQ = 'https://secure.opinionlab.com/ccc01/comment_card_json_4_0_b.asp',
        form,
        interval,
        boundFunction,
        repeatBreaker = false,
        self = this,
        bodyShadow,
        topShadow,
        bottomShadow,
        shadows,
        postMessageHandler,
        width,
        offsetTop,
        description = d.createElement('span');

      function destroyOnPageCC(e) {
        if (e && e.preventDefault) { e.preventDefault(); }
        document.body.focus();
        frame.tabIndex = -1;
        frame.title = "empty";
        frame['aria-hidden'] = 'true';
        overlay.style.display = 'none';
        overlay.className = '';
        d.body.removeChild(wrapper);
        if (window.postMessage) {
          OOo.removeEventListener(window, 'message', postMessageHandler);
        } else {
          window.clearInterval(interval);
        }
        repeatBreaker = false;
        self.onPageCardVisible = false;
        return false;
      }

      postMessageHandler = OOo.Ocode.postMessageHandler(function(message) {
        var height = parseInt(message, 10),
          innerHeight, frameHeight;
        if (height > 0) {
          if (repeatBreaker) { return; }
          repeatBreaker = true;
          innerHeight = window.innerHeight || d.documentElement.clientHeight || d.body.clientHeight;
          frameHeight = height;
          offsetTop = wrapper.offsetTop;

          if (frameHeight + offsetTop > innerHeight) {
            frameHeight = innerHeight - 40 - offsetTop;
          }

          frame.style.width = '555px';
          iwrapper.style.width = '555px';

          frame.style.height = frameHeight + 'px';
          wrapper.style.visibility = 'visible';
          if (iclose.clientHeight < 20) { iclose.style.height = wrapper.offsetHeight + 'px'; }
          overlay.className = "no_loading";
          self.onPageCardVisible = true;
          form && d.body.removeChild(form);
        } else if (message === 'submitted') { destroyOnPageCC(); }

        if (OOo.Browser.IE && d.compatMode === "BackCompat") { window.scrollTo(0, 0); }
      }, self.options.commentCardUrl);


      thisOpt.metrics.type = 'OnPage';
      OOo.Cache.overlay = overlay;

      overlay.id = 'oo_overlay';
      overlay.style.display = 'block'; //may have been hidden by previous invocation of an onPageCard
      overlay.className = '';
      iwrapper.className = 'iwrapper';
      wrapper.className = 'oo_cc_wrapper';
      wrapper.setAttribute('role', 'alert');
      wrapper.setAttribute('aria-describedby', 'comment_card_description');
      description.className = 'screen_reader';
      description.id = 'comment_card_description';
      description.innerHTML = 'Please leave your feedback in the comment card you just activated';
      wrapper.appendChild(description);
      close.className = 'oo_cc_close';
      close.innerHTML = '<span class="screen_reader">Close dialog</span><span aria-hidden="true">&#10006;</span>';

      close.title = thisOpt.closeTitle ? thisOpt.closeTitle : 'Close dialog';

      if (!d.addEventListener) {
        iwrapper.style.outline = '1px solid #cdcdcd';
      }

      wrapper.style.visibility = 'hidden'; //hide the frame till it's ready

      close.tabIndex = 0;
      close.onkeyup = function(e) {
        var event = e || window.event;
        if (event.keyCode !== 13) { return; }
        destroyOnPageCC();
      };

      if (OOo.Browser.IE) {
        frame.frameBorder = '0';
        if (!window.XMLHttpRequest || d.compatMode === "BackCompat") {
          width = Math.max(d.documentElement.clientWidth, d.body.offsetWidth);
          overlay.style.position = 'absolute';
          overlay.style.width = d.compatMode === "BackCompat" ? (width - 21) + 'px' : width + 'px';
          overlay.style.height = Math.max(d.documentElement.clientHeight, d.body.offsetHeight) + 'px';
          wrapper.style.position = 'absolute';
          OOo.addEventListener(window, 'scroll', function() {
            overlay.style.top = (d.body.scrollTop + document.body.clientHeight - overlay.clientHeight) + 'px';
            wrapper.style.top = (d.body.scrollTop + offsetTop + 25) + 'px';
          });
        }
      }

      OOo.addEventListener(close, 'click', destroyOnPageCC);
      if (opt.closeWithOverlay && !OOo.Browser.isMobile) {
        wrapper.appendChild(iclose);
        iclose.onclick = destroyOnPageCC;
        overlay.onclick = destroyOnPageCC;
      }

      frame.src = ' ';
      frame.name = frameName;
      frame.title = 'Comment Card';

      iwrapper.appendChild(close);
      iwrapper.appendChild(frame);
      wrapper.appendChild(iwrapper);
      tempContainer.appendChild(wrapper);
      tempContainer.appendChild(overlay);
      d.body.appendChild(tempContainer);


      if (window.postMessage) {
        OOo.addEventListener(window, "message", postMessageHandler);
      } else {
        interval = setInterval(postMessageHandler, 500);
      }

      thisOpt.metrics.time2 = (new Date()).getTime();

      if (thisOpt.constructCommentCardUrl) {
        frame.setAttribute('src', OOo.appendOOForm(thisOpt, frameName));
      } else {
        form = OOo.appendOOForm(thisOpt, frameName);
        form.submit();
      }
    }
  });

  OOo.extend(OOo.Ocode, {
    postMessageHandler: function(callback, commentCardUrl, loc) {
      return function(e) {
        var messageURL = 'https://secure.opinionlab.com',
          message;
        if (!loc) { loc = location; }
        if ((e && !(e.origin === messageURL || e.origin.indexOf(commentCardUrl) !== 0)) || (!e && loc.hash.search('OL=') === -1)) { return false; }
        message = e ? e.data : loc.hash.split('=').pop();
        if (!e && location.hash) { location.hash = ''; }
        callback(message);
        return message;
      };
    }
  });

  OOo.Invitation = function(options) {
    this.options = {
      tunnelCookie: 'oo_inv_tunnel',
      repromptTime: 604800,
      responseRate: 50,
      useBrowserStorage: false,
      repromptCookie: 'oo_inv_reprompt',
      promptMarkup: 'oo_inv_prompt.html',
      promptStyles: 'oo_inverstitial_style.css',
      percentageCookie: 'oo_inv_percent',
      pagesHitCookie: 'oo_inv_hit',
      cookieDomain: '',
      popupType: 'popunder',
      promptDelay: 0,
      neverShowAgainButton: false,
      loadPopupInBackground: false,
      truncatePrevCurrentMetrics: false,
      disablePrevCurrentMetrics: false,
      tealeafCookieName: 'TLTSID',
      monitorWindow: 'oo_inv_monitor.html',
      companySlogan: 'We value your opinion',
      beforePrompt: OOo.K,
      callBacks: {
        prompt: '',
        yesClick: '',
        noClick: '',
        closeClick: ''
      },
      inviteMarkup: "<div id='oo_invitation_prompt' role='dialog' aria-describedby='oo_invite_message'><div id='oo_invitation_company_logo'></div><div id='oo_invite_content'><p id='oo_invite_message'>After your visit, would you be willing to provide some quick feedback?<br /><br />(It will only take a minute)</p><p class='prompt_button'><a href='#' id='oo_launch_prompt'>Yes<span class='screen_reader'>This will open a new window</span></a></p><p class='prompt_button'><a href='#' id='oo_no_thanks'>No Thanks</a></p><p id='ol_invitation_brand_logo'><span aria-label='Powered by OpinionLab.'></span></p></div><a id='oo_close_prompt' href='#' aria-label='Close dialog'><div class='screen_reader'>Close dialog</div><span aria-hidden='true'>x</span></a></div><!--[if IE 8]><style>/* IE 8 does not support box-shadow */#oo_invitation_prompt #oo_invite_content { width: 400px; padding: 40px 49px 20px 49px; border: 1px solid #ccc; }</style><![endif]-->"
    };
    this.popupShown = false;
    OOo.extend(this.options, options);

    var opt = this.options,
      pagesHit = parseInt(OOo.readCookieOrStorage(opt, opt.pagesHitCookie), 10) || 0;

    OOo.Invitation.friendlyDomains = opt.friendlyDomains || null;

    var cookieOODynamicRewrite = {
      weight: Number(OOo.readCookieOrStorage(opt, 'oo_OODynamicRewrite_weight')),
      searchPattern: OOo.readCookieOrStorage(opt, 'oo_OODynamicRewrite_searchPattern'),
      replacePattern: OOo.readCookieOrStorage(opt, 'oo_OODynamicRewrite_replacePattern')
    };
    OOo.eraseCookieOrStorage(opt, 'oo_OODynamicRewrite_weight');
    OOo.eraseCookieOrStorage(opt, 'oo_OODynamicRewrite_searchPattern');
    OOo.eraseCookieOrStorage(opt, 'oo_OODynamicRewrite_replacePattern');

    if (!window.OOoDynamicRewrite || window.OOoDynamicRewrite.weight < cookieOODynamicRewrite.weight) {
      window.OOoDynamicRewrite = cookieOODynamicRewrite;
    }

    if (window.OOoDynamicRewrite && ('number' === typeof window.OOoDynamicRewrite.weight) && !isNaN(window.OOoDynamicRewrite.weight)) {
      OOo.createCookieOrStorage(opt, 'oo_OODynamicRewrite_weight', window.OOoDynamicRewrite.weight, '', opt.cookieDomain);
      if (window.OOoDynamicRewrite.searchPattern) {
        OOo.createCookieOrStorage(opt, 'oo_OODynamicRewrite_searchPattern', window.OOoDynamicRewrite.searchPattern, '', opt.cookieDomain);
      }
      if (window.OOoDynamicRewrite.replacePattern) {
        OOo.createCookieOrStorage(opt, 'oo_OODynamicRewrite_replacePattern', window.OOoDynamicRewrite.replacePattern, '', opt.cookieDomain);
      }
    }

    if (location.search.search('evs') !== -1 || OOo.readCookieOrStorage(opt, 'oo_evs_friendly') === 'yes') {
      OOo.eraseCookieOrStorage(opt, 'oo_evs_friendly');
      opt.loadPopupInBackground = true;
      this.launchPopup();
      OOo.createCookieOrStorage(opt, opt.repromptCookie, 1, opt.repromptTime === -1 ? 0 : opt.repromptTime, opt.cookieDomain);
    }
    setTimeout(function() {
      if (!window.oo_inv_monitor) { return; }
      if (opt.area && location.href.search(opt.area) === -1) {
        this.options.popupType = 'popup';
        this.launchPopup();
      } else if (opt.goal && location.href.search(opt.goal) !== -1) {
        window.oo_inv_monitor.close();
      }
    }.bind(this), 1600);

    if (OOo.readCookieOrStorage(opt, opt.repromptCookie)) { return; }

    if (opt.thirdPartyCookies && OOo.checkThirdPartyCookies(opt.thirdPartyCookies)) { return; }

    if (!OOo.readCookieOrStorage(opt, opt.percentageCookie)) {
      OOo.createCookieOrStorage(opt, opt.percentageCookie, (Math.random() > 1 - (opt.responseRate / 100)) ? "1" : "0", '', opt.cookieDomain);
    }
    if (typeof opt.promptTrigger !== 'undefined') {
      if (opt.promptTrigger instanceof RegExp) {
        if (!window.location.href.match(opt.promptTrigger)) { return; }
      } else if (opt.promptTrigger instanceof Array) {
        if (!OOo.checkTunnel(location.pathname, opt.promptTrigger, opt.tunnelCookie)) { return; }
      }
    }
    pagesHit += 1;
    OOo.createCookieOrStorage(opt, opt.pagesHitCookie, pagesHit, '', opt.cookieDomain);
    if (opt.pagesHit && pagesHit < opt.pagesHit) { return; }
    OOo.eraseCookieOrStorage(opt, opt.tunnelCookie);
    if (OOo.readCookieOrStorage(opt, opt.percentageCookie) === '1') {
      window.setTimeout(function() {
        OOo.createCookieOrStorage(opt, opt.repromptCookie, 1, opt.repromptTime, opt.cookieDomain);
        this.options.beforePrompt();
        this.getPrompt();
      }.bind(this), opt.promptDelay * 1000);
    }
  };

  OOo.Invitation.notifyFriendlyLocationChange = function(url) {
    if (window.oo_inv_monitor) {
      OOo.createCookieOrStorage(opt, 'oo_evs_friendly', 'yes', '', opt.cookieDomain);
    }
  };

  OOo.Invitation.prototype = {
    getPrompt: function() {
      OOo.getPrompt.call(this);
    },

    showPrompt: function(markup) {
      OOo.showPrompt.call(this, markup, this.launchPopup);
    },

    launchPopup: function(e) {
      if (this.popupShown) { return; }
      this.popupShown = true;

      var evt = e || window.event;
      if (typeof evt !== 'undefined') {
        if (evt.preventDefault && evt.stopPropagation) {
          evt.preventDefault();
          evt.stopPropagation();
        } else {
          evt.returnValue = false;
        }
      }

      var
        opt = this.options,
        referrer = window.location.href,
        url = opt.popupType === 'popup' ? 'https://secure.opinionlab.com/ccc01/comment_card.asp?' : opt.pathToAssets + opt.monitorWindow + '?time1=' + (new Date()).getTime() + '&',
        urlParams,
        customVars = [],
        popupDimensions = opt.asm ? [555, 500] : (OOo.Browser.Chrome ? [400, 400] : [400, 350]),
        popup,
        metrics = OOo.createMetrics(),
        prependCustomVar = OOo.readCookieOrStorage(opt, opt.tealeafCookieName),
        popupOptions;

      if (opt.clickTalePID && window.ClickTaleGetUID && window.ClickTaleGetSID || window.ClickTaleGetPID && window.ClickTaleGetUID && window.ClickTaleGetSID) { prependCustomVar += '|' + [opt.clickTalePID || window.ClickTaleGetPID(), window.ClickTaleGetUID(), window.ClickTaleGetSID()].join('/'); }

      popupDimensions = opt.newWindowSize || popupDimensions;
      popupOptions = 'scrollbars=1,resizable=1,location=no,status=no,width=' + popupDimensions[0] + ',height=' + popupDimensions[1];

      if (opt.referrerRewrite) { metrics.referer = OOo.referrerRewrite(opt.referrerRewrite); }

      if (opt.truncatePrevCurrentMetrics) { metrics.prev = OOo.truncateMetric(metrics.prev);
        metrics.currentURL = OOo.truncateMetric(metrics.currentURL); }

      if (opt.disablePrevCurrentMetrics) { metrics.prev = '';
        metrics.currentURL = ''; }

      if (opt.thirdPartyCookies) { OOo.setThirdPartyCookies(opt.thirdPartyCookies); }

      urlParams = OOo.toQueryString(metrics) + '&type=Invitation';
      if (opt.customVariables) { urlParams += '&customVars=' + encodeURIComponent(OOo.serialize(opt.customVariables)); }
      urlParams += '&custom_var=' + OOo.createLegacyVars(opt.legacyVariables, prependCustomVar);
      if (opt.asm) {
        urlParams += '&asm=2';
        popupOptions += ',scrollbars=1';
      }
      url += urlParams;
      if (url.match(/\?/g).length === 2) url = url.replace(/\?([^?]*)$/, '&$1');

      this.popup = popup = window.open(url, 'OnlineOpinionInvitation', popupOptions);

      if (!opt.loadPopupInBackground && OOo.$('oo_container')) { OOo.hidePrompt(evt); }

    },

    killPrompt: function(e) {
      var evt = e || window.event;
      if (this.options.callBacks && typeof this.options.callBacks.noClick === 'function') { this.options.callBacks.noClick(); }
      OOo.createCookieOrStorage(this.options, this.options.repromptCookie, 1, 157680000, opt.cookieDomain); // Don't show again for 5 years
      OOo.hidePrompt(evt);
    }
  };

  OOo.extend(OOo.Invitation, {
    navigateToFriendlyDomain: function(url) {
      location.href = url;
    }
  });

  OOo.Waypoint = function (options) {
    var browser = OOo.Browser;

    if (options.disableMobile && browser.isMobile) { return; }
    if (options.disableNoniOS && browser.isMobileNonIOS) { return; }

    this.options = {
      pathToAssets: '/onlineopinionV5/',
      waypointMarkup: 'oo_waypoint.html',
      companySlogan: 'Give us feedback',
      companyLogo: 'waypoint_logo.png',
      linkFocus: true,
      categories: {
        website: {
          tealeafCookieName: 'TLTSID',
          waypointIcon: 'waypoint_icon.png',
          buttonText: 'Website'
        },
        store: {
          referrerRewrite: {
            searchPattern: /:\/\//,
            replacePattern: '://store.'
          },
          tealeafCookieName: 'TLTSID',
          waypointIcon: 'waypoint_icon.png',
          buttonText: 'Store'
        },
        product: {
          referrerRewrite: {
            searchPattern: /:\/\//,
            replacePattern: '://product.'
          },
          tealeafCookieName: 'TLTSID',
          waypointIcon: 'waypoint_icon.png',
          buttonText: 'Product'
        },
        other: {
          referrerRewrite: {
            searchPattern: /:\/\//,
            replacePattern: '://other.'
          },
          tealeafCookieName: 'TLTSID',
          waypointIcon: 'waypoint_icon.png',
          buttonText: 'Other'
        }
      },
      wpmarkup: "<div id='oo_waypoint_prompt' role='dialogue' aria-describedby='oo_waypoint_message'><div id='oo_waypoint_company_logo'></div><div id='oo_waypoint_content'><p id='oo_waypoint_message'>Select a category</p><p id='waypoint_icons'></p><p id='ol_waypoint_brand_logo'><span aria-label='Powered by OpinionLab.'></span></p></div><a id='oo_waypoint_close_prompt' href='#' aria-label='Close dialog'><div class='screen_reader'>Close dialogue</div><span aria-hidden='true'>x</span></a></div><!--[if IE 8]><style>/* IE 8 does not support box-shadow */#oo_waypoint_prompt #oo_waypoint_content { width: 400px; padding: 40px 49px 20px 49px; border: 1px solid #ccc; }</style><![endif]-->"
    };

    OOo.extend(this.options, options);

    var opt = this.options, categories = opt.categories;

    for (var key in categories) {
      if (categories.hasOwnProperty(key)) {
        if (typeof opt.categories[key].oCode === 'object') {
          var extension = {};
          extension[key] = new OOo.Ocode(categories[key].oCode);
          OOo.extend(OOo.Waypoint, extension);
        }
      }
    }

    OOo.extend(OOo.Waypoint, {
      getWaypoint: function () {
        this.getWaypoint();
      }.bind(this)
    });
  };

  OOo.Waypoint.prototype = {
    getWaypoint: function () {
      OOo.getWaypoint.call(this);
    },
    showWaypoint: function (markup) {
      OOo.showWaypoint.call(this, markup);
    },
    killWaypoint: function (e) {
      var evt = e || window.event;
      OOo.hideWaypoint(evt);
    }
  };

  OOo.extend(OOo, {
    appendWaypoint: function (id) {
      var el = OOo.$(id);
      if (!!el) {
        if (!OOo.Browser.isMobile) {
          OOo.addEventListener(el, 'click', function (e) {
            var evt = e || window.event;
            if (evt.preventDefault && evt.stopPropagation) {
              evt.preventDefault();
              evt.stopPropagation();
            } else {
              evt.returnValue = false;
            }
            OOo.Waypoint.getWaypoint();
          }, false);
          OOo.addEventListener(el, 'keydown', function (e) {
            var evt = e || window.event;
            if (evt.keyCode !== 13) { return; }
            if (evt.preventDefault && evt.stopPropagation) {
              evt.preventDefault();
              evt.stopPropagation();
            } else {
              evt.returnValue = false;
            }
            OOo.Waypoint.getWaypoint();
          }, false);
        }
      }
    }
  });

  OOo.extend(OOo, {
    appendWaypointMobile: function (el, mobileTouchNum) {
      var touches = 0;
      var mobileTouches = mobileTouchNum || 2;
      if (typeof el === "string") var el = OOo.$(el);
      if (!!el) {
        if (OOo.Browser.isMobile) {
          if ("ontouchstart" in window && "ontouchend" in window && "ontouchmove" in window) {
            OOo.addEventListener(el, "touchstart", function (e) {
              touches++;
            }, false);

            OOo.addEventListener(el, "touchend", function (e) {
              var evt = e || window.event;
              if (evt.preventDefault && evt.stopPropagation) {
                evt.preventDefault();
                evt.stopPropagation();
                if (touches >= mobileTouches) {
                  OOo.Waypoint.getWaypoint();
                  touches = 0;
                }
              } else {
                evt.returnValue = false;
              }
            }, false);

            OOo.addEventListener(el, "touchmove", function (e) {
              touches = 0;
            }, false);
          } else {
            OOo.addEventListener(el, "click", function (e) {
              var evt = e || window.event;
              if (evt.preventDefault && evt.stopPropagation) {
                evt.preventDefault();
                evt.stopPropagation();
              } else {
                evt.returnValue = false;
              }
              OOo.Waypoint.getWaypoint();
            }, false);
          }
        }

      }
    }
  });

  return OOo;
}));

